/**
 * Resolve Cockpit API base URL for storefront scripts (gap-filler, wishlist, reserve).
 */
(function () {
  const isProductionShop = () => {
    const host = String(window.location.hostname || '').toLowerCase();
    return host === 'kartenladen24.de' || host === 'www.kartenladen24.de';
  };

  const resolveCockpitApiBase = () => {
    const fromHtml = document.documentElement.dataset.cockpitApiBase || '';
    const fromBody = document.body?.dataset?.cockpitApiBase || '';
    const fromSection = document.querySelector('[data-api-base]')?.dataset?.apiBase || '';
    const explicit = String(fromHtml || fromBody || fromSection || window.KL24_COCKPIT_API_BASE || '')
      .trim()
      .replace(/\/$/, '');
    if (explicit) {
      if (isProductionShop() && explicit.includes('loca.lt')) {
        console.warn('[KL24] Ignoriere loca.lt Cockpit-URL auf Produktion — nutze App Proxy.');
      } else {
        return explicit;
      }
    }
    if (isProductionShop()) {
      return '/apps/kl24-cockpit';
    }
    const useAppProxy = document.documentElement.dataset.cockpitUseAppProxy === 'true';
    if (useAppProxy) {
      return '/apps/kl24-cockpit';
    }
    return '';
  };

  /** Try explicit theme URL first, then Shopify app proxy on production. */
  const resolveCockpitApiBases = () => {
    const bases = [];
    const push = (value) => {
      const normalized = String(value || '').trim().replace(/\/$/, '');
      if (normalized && !bases.includes(normalized)) bases.push(normalized);
    };
    push(resolveCockpitApiBase());
    if (isProductionShop()) push('/apps/kl24-cockpit');
    return bases;
  };

  const cockpitRequestHeaders = (apiBase, extra = {}) => {
    const headers = { Accept: 'application/json', ...extra };
    if (apiBase.includes('loca.lt')) {
      headers['Bypass-Tunnel-Reminder'] = 'true';
    }
    if (apiBase.includes('ngrok-free.app') || apiBase.includes('ngrok-free.dev')) {
      headers['ngrok-skip-browser-warning'] = '69420';
    }
    return headers;
  };

  window.KL24 = window.KL24 || {};
  window.KL24.resolveCockpitApiBase = resolveCockpitApiBase;
  window.KL24.resolveCockpitApiBases = resolveCockpitApiBases;
  window.KL24.cockpitRequestHeaders = cockpitRequestHeaders;
})();
